export interface TTechnicalTextsState {
  data: {
    text_unauthorized: string;
    text_unaccess: string;
    text_unregistered: string;
  } | null;
  error: string | null;
  loading: boolean;
}

enum ActionTypes {
  GET_TECHNICAL_TEXTS_R = 'GET_TECHNICAL_TEXTS_R',
  GET_TECHNICAL_TEXTS_S = 'GET_TECHNICAL_TEXTS_S',
  GET_TECHNICAL_TEXTS_E = 'GET_TECHNICAL_TEXTS_E',
}

export default ActionTypes;
